module.exports = __webpack_public_path__ + "fonts/HanaMinA.b48893dc.ttf";